<template>
  <div
    id="app"
    class="min-h-screen bg-gray-300 antialiased flex flex-col"
  >
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
};
</script>
<style src="@/styles/main.css" />
